import { formaters } from "vincent-utils";
import moment from "moment";
import { PatientFlags } from "cadendar-shared";
import Flag from "../../patients/components/Flag.tsx";

export interface RdvInfoPopupProps {
  top: number;
  left: number;
  rdv: {
    birthdate: string | null;
    name: string | null;
    forename: string | null;
    hour: number;
    minute: number;
    duration: number;
    object: string | null;
    addressed_by: string | null;
    patient_flags: PatientFlags | null;
  };
}

const RdvInfoPopup = (props: RdvInfoPopupProps) => {
  const { top, left } = props;
  const { rdv } = props;
  const style = {
    position: "fixed" as const,
    top: top,
    left: left,
    zIndex: 10,
  };
  const { birthdate } = rdv;
  const ageObj = birthdate
    ? formaters.getAgeFromDDN(
        moment(birthdate, "DD/MM/YYYY").toDate(),
        new Date()
      )
    : { annees: 0, mois: 0 };
  const patientFlagsComps = rdv.patient_flags && (
    <div id={rdv.patient_flags + "div"} key={"flag" + rdv.patient_flags}>
      {rdv.patient_flags}
    </div>
  );

  return (
    <div id="rdvinfopopup" className="p-[10px] min-w-[200px] min-h-[100px] bg-white shadow-[3px_3px_10px_rgba(0,0,0,0.3)]" style={style}>
      <div className="bg-[#545454] text-white text-center m-[1px] select-none">
        {rdv.name && rdv.name.toUpperCase()}{" "}
        {formaters.capitaliseEveryFirstLetter(rdv.forename || "")}
      </div>
      <div>
        {rdv.hour}h{formaters.convertZeroToDoubleZero(rdv.minute)}
      </div>
      <div>durée:{formaters.convertMinToHMinString(rdv.duration)}</div>
      <div>{rdv.object}</div>
      {ageObj ? (
        <div>
          {ageObj.annees} ans {ageObj.mois} mois
        </div>
      ) : null}
      {rdv.addressed_by && rdv.addressed_by.length > 1 ? (
        <div>Adressé par {rdv.addressed_by}</div>
      ) : null}

      {rdv.patient_flags ? <Flag flag={rdv.patient_flags} /> : null}
    </div>
  );
};

export default RdvInfoPopup;
